import React from 'react'
import { Link } from 'react-router-dom'
import { Button as SonansButton } from '@sonans/components'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode
    mode?: 'primary' | 'secondary' | 'pagination'
    size?: 'sm' | 'default' | 'none'
    icon?: 'left' | 'up' | 'right' | 'down' | 'close' | 'none'
    smallShadow?: boolean
    navigateTo?: string
    className?: string
}

function getIconName(icon: ButtonProps['icon']): string | undefined {
    switch (icon) {
        case 'left': return 'arrow_back'
        case 'up': return 'arrow_upward'
        case 'right': return 'arrow_forward'
        case 'down': return 'arrow_downward'
        case 'close': return 'close'
        default: return undefined
    }
}

export function Button({
    children,
    mode = 'primary',
    size = 'default',
    icon = 'none',
    navigateTo = '',
    smallShadow: _smallShadow,
    className = '',
    ...props
}: ButtonProps) {
    const variantMap = {
        primary: 'primary',
        secondary: 'secondary',
        pagination: 'primary',
    } as const

    const sizeMap = {
        sm: 'small',
        default: 'large',
        none: 'large',
    } as const

    const iconName = getIconName(icon)
    const resolvedSize = mode === 'pagination' ? 'iconOnly' : sizeMap[size]

    const button = (
        <SonansButton
            {...(props as any)}
            variant={variantMap[mode]}
            size={resolvedSize}
            withIcon={!!iconName}
            icon={iconName}
            iconPosition={icon === 'left' ? 'left' : 'right'}
            className={className}
        >
            {children}
        </SonansButton>
    )

    if (navigateTo) {
        return <Link to={navigateTo}>{button}</Link>
    }

    return button
}
